import { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { setToaster } from '../../common/commonSlice';
import Toaster from './Toaster';

const ContentPage = styled('div')(({ theme }) => ({
  padding: '30px 0',
  minHeight: '500px',
  marginBottom: '15px',
  background: 'transparent',
  height: '80vh',
  [theme.breakpoints.down('sm')]: {
    padding: '70px 0 0',
  },
}));

interface PageContentProps {
  children: ReactNode;
}

export default function PageContent({ children }: PageContentProps) {
  const dispatch = useAppDispatch();
  const toaster = useAppSelector((state) => state.common.toaster);

  const handleToastClose = (_event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;

    dispatch(setToaster({
      open: false,
      message: '',
    }));
  };

  return (
    <ContentPage>
      {children}
      <Toaster
        open={toaster.open}
        onClose={handleToastClose}
        severity={toaster.severity}
        message={toaster.message}
      />
    </ContentPage>
  );
}
